import { inject, PropTypes, observer } from 'mobx-react';
import propTypes from 'prop-types';
import { GenerateExcel } from '../../../utils/excel-handler/GenerateExcel';
import * as constants from '../../../constants/constants';
import { ExportOption } from './ExportOption/ExportOption.jsx';
import { PesIcon, PdpIconTooltip } from '@pes-ui/components-react';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';
import { extractExcelData } from '../../../utils/excel-handler/dataExtractor';
import { useEffect, useMemo } from 'react';

const _Export = ({ labelsStore, cartStore, documentsStore, substRootStore, optionsStore }) => {
  const configurationsCount = cartStore.allGroups.filter((group) => !!group.hiveId).length;
  const exportAllXmlLabel = labelsStore.exportXmlAll.replace(constants.REPLACE_NUMBER_OF_FILES, '').trim();
  const exportAllHiveUrl = documentsStore.getDownloadUrl(constants.exportType.MY_PRODUCTS_XML);
  return (
    <>
      <div className="cart-export__title actions-block__row">{labelsStore.sectionProductList}</div>
      <ExportOption
        useHref="file_xlsx"
        label={labelsStore.exportExcel}
        onExport = {() => { 
         const excelData = extractExcelData(labelsStore, cartStore, substRootStore, optionsStore, document.dir);
         (new GenerateExcel(excelData)).exportToExcel();
        }}
        autotestsId="cart-link-download-cart-excel"
      />
      <ExportOption
        useHref="action_pdf_report"
        label={labelsStore.exportPdf}
        // #TODO: Filename will be coming from BE
        onExport={() => documentsStore.downloadFile(constants.exportType.MY_PRODUCTS_PDF,'My Products.pdf')}
        exportOptionType={constants.exportType.MY_PRODUCTS_PDF}
        autotestsId="cart-link-download-cart-PDF"
      />
      <div className="cart-export__title actions-block__row">{labelsStore.sectionProductDatasheet}</div>
      <ExportOption
        useHref="action_pdf_report"
        label={labelsStore.exportPdf}
        exportOptionType={constants.exportType.MY_PRODUCTS_PDS_PDF}
        // #TODO: Filename will be coming from BE
        onExport={() => documentsStore.downloadFile(constants.exportType.MY_PRODUCTS_PDS_PDF, 'My Products PDS.pdf')}
        autotestsId="cart-link-download-datasheets-PDF"
      />
      {!!configurationsCount
      && (
        <>
          <div className="cart-export__title actions-block__row">
            {labelsStore.sectionConfigurationFiles}
            <PdpIconTooltip
              class="indent-words--this"
              icon="information_circle"
              iconSize={pesIconSizes.MICRO}
              iconColor="blue"
              position="top"
              >
              {labelsStore.xmlTooltip}
            </PdpIconTooltip>
          </div>
          <div className="actions-block__row">
            <PesIcon class="actions-block__icon" size={pesIconSizes.SMALL}>
              file_xml
            </PesIcon>
            <a 
              href={exportAllHiveUrl}
              className="pes-link actions-block__cta">
              {exportAllXmlLabel}
              <span className="actions-block__text--secondary">
                {`(${configurationsCount})`}
              </span>
            </a>
          </div>
        </>
      )}

    </>
  );
};

_Export.propTypes = {
  labelsStore: propTypes.shape({
    sectionProductList: propTypes.string.isRequired,
    sectionProductDatasheet: propTypes.string.isRequired,
    sectionConfigurationFiles: propTypes.string.isRequired,
    exportAs: propTypes.string.isRequired,
    exportExcel: propTypes.string.isRequired,
    exportPdf: propTypes.string.isRequired
  }).isRequired,
  cartStore: propTypes.shape({
    allGroups: PropTypes.observableArray
  }).isRequired,
  documentsStore: propTypes.shape({
    downloadFile: propTypes.func.isRequired
  }).isRequired,
  substRootStore: propTypes.shape({
    getSubstSectionStores: propTypes.func.isRequired,
    substitutions: PropTypes.observableArray
  }),
};

export const Export = inject(
  'labelsStore' ,
  'cartStore' ,
  'documentsStore',
  'substRootStore',
  'optionsStore')(observer(_Export));
